import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

export const inputVariants = cva(
  cn(
    "block rounded-xl w-full border font-normal text-neutral-title transition-all duration-300",
    "focus:outline-0 focus:duration-200",
    "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground",
    "placeholder:text-neutral-text",
    "disabled:cursor-not-allowed disabled:opacity-50",
  ),
  {
    variants: {
      variant: {
        primary: cn(
          "border-neutral-disabled bg-white",
          "hover:border-brand-secondBg",
          "focus:border-brand-primary focus:shadow-[0_0_0_4px_#EAEBF7]",
          "placeholder-neutral-text",
          "bg-brand-secondBg/25 focus:bg-transparent",
        ),
        error: cn(
          "border-danger-primary bg-danger-mainBg",
          "hover:bg-white focus:bg-white",
          "shadow-[0_0_0_4px_#FDF4F4]",
          "placeholder-danger-primary/50",
        ),
      },
      inputSize: {
        sm: "px-3 py-2 text-sm",
        md: "px-4 py-3",
      },
      inReview: {
        true: "p-0 !border-transparent !shadow-none !bg-transparent rounded-sm pointer-events-none",
        false: cn(
          "disabled:pointer-events-none disabled:bg-neutral-secondBg",
          "disabled:text-neutral-text disabled:placeholder-neutral-disabled",
        ),
      },
    },
    defaultVariants: {
      variant: "primary",
      inputSize: "md",
      inReview: false,
    },
  },
)

export const inputWrapperVariants = cva("space-y-1", {
  variants: {
    inReview: {
      true: "space-y-2",
      false: "space-y-1",
    },
  },
  defaultVariants: {
    inReview: false,
  },
})

export const inputLabelVariants = cva("flex items-center transition-all duration-300", {
  variants: {
    inReview: {
      true: "mb-2 text-base font-medium text-neutral-title",
      false: "mb-1 text-sm text-neutral-title",
    },
  },
  defaultVariants: {
    inReview: false,
  },
})

export const inputIconContainerVariants = cva("absolute flex items-center justify-center", {
  variants: {
    position: {
      left: "left-3",
      right: "right-3",
    },
    size: {
      sm: "w-4 h-4",
      md: "w-5 h-5",
    },
  },
  defaultVariants: {
    position: "left",
    size: "md",
  },
})

export type InputVariants = VariantProps<typeof inputVariants>
export type InputWrapperVariants = VariantProps<typeof inputWrapperVariants>
export type InputLabelVariants = VariantProps<typeof inputLabelVariants>
export type InputIconContainerVariants = VariantProps<typeof inputIconContainerVariants>
